import React from 'react';
import Header from '../../components/reusable/Header.jsx';
import BackButton from '../../components/reusable/buttons/BackButton.jsx';
import PageTitle from '../../components/reusable/PageTitle.jsx';

const PrivacyPolicy = () => {
    return (
        <div className='container mx-auto px-4 py-8'>
            <Header>
                <BackButton from='' />
            </Header>
            <PageTitle>
                <div className='text-[20px] uppercase'>PRIVACY POLICY</div>
            </PageTitle>

            <p className='text-sm mb-4'>Last updated: 16/09/2024</p>

            <div className='prose max-w-none'>
                <p>
                    Welcome to PLAYER, operated by PLAYERAPP LTD (Company No.
                    14382941). This Privacy Policy explains how we collect, use,
                    and protect your personal data when you use our website,
                    mobile apps, and services (collectively, the "Platform"). By
                    using the Platform, you consent to the data practices
                    described in this policy.
                </p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    1. Definitions
                </h2>
                <ul className='list-disc pl-6'>
                    <li>
                        "Platform" refers to the PLAYER website, mobile apps,
                        and associated services.
                    </li>
                    <li>
                        "Personal Data" refers to any information that relates
                        to an identified or identifiable individual.
                    </li>
                    <li>
                        "Cookies" are small text files placed on your device to
                        collect information about your browsing activities.
                    </li>
                </ul>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    2. Who We Are and What This Policy Covers
                </h2>
                <p>
                    PLAYERAPP LTD, located at 4th Floor Charles House, 108-110
                    Finchley Road, London, United Kingdom, NW3 5JJ, is the data
                    controller responsible for your Personal Data. This Privacy
                    Policy covers our practices regarding the collection, use,
                    and protection of your Personal Data when using the
                    Platform.
                </p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    3. Information We Collect
                </h2>
                <p>We collect the following types of information:</p>
                <ul className='list-disc pl-6'>
                    <li>
                        <strong>Personal Data:</strong> Includes your name,
                        email address, phone number, date of birth, and other
                        contact details.
                    </li>
                    <li>
                        <strong>Football-related Data:</strong> Includes your
                        football club history, performance data, and other
                        career-related information.
                    </li>
                    <li>
                        <strong>Content Data:</strong> Includes photos, videos,
                        and other content you upload to the Platform.
                    </li>
                    <li>
                        <strong>Usage Data:</strong> Includes information about
                        how you use the Platform, such as IP address, browser
                        type, and operating system.
                    </li>
                </ul>
                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    4.How and Why We Use Information
                </h2>
                <p>We may share your Personal Data with:</p>
                <ul className='list-disc pl-6'>
                    <li>Provide, operate, and improve the Platform.</li>
                    <li>Manage your account and provide customer support.</li>
                    <li>
                        Communicate with you, including sending updates,
                        notifications, and promotional messages (with your
                        consent).
                    </li>
                    <li>Analyse usage patterns and improve our services.</li>
                    <li>
                        We will only use your Personal Data for the purposes for
                        which it was collected, as described in this Privacy
                        Policy, or as required by law.
                    </li>
                </ul>
                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    5. Sharing Information
                </h2>
                <p>We collect the following types of information:</p>

                <ul className='list-disc pl-6'>
                    <li>
                        <strong>Service Providers:</strong> Third parties who
                        provide services on our behalf, such as data hosting and
                        customer support.
                    </li>
                    <li>
                        <strong>Business Transfers: </strong>In the event of a
                        merger, acquisition, or other business transaction, your
                        Personal Data may be transferred as part of the
                        transaction.
                    </li>
                    <li>
                        <strong>Legal Requirements: </strong>To comply with
                        legal obligations or to protect our rights and the
                        rights of others.
                    </li>
                    <li>
                        <strong>Usage Data:</strong> Includes information about
                        how you use the Platform, such as IP address, browser
                        type, and operating system.
                    </li>
                    <li>We do not sell your Personal Data to third parties.</li>
                </ul>
                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    6. How Long We Keep Information
                </h2>
                <p>
                    We generally retain your Personal Data for as long as
                    necessary to fulfil the purposes for which it was collected.
                    For example, web server logs containing information like IP
                    addresses and browser types are kept for approximately 30
                    days to analyse traffic and investigate issues.
                </p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    7. Security
                </h2>
                <p>
                    We implement appropriate technical and organisational
                    measures to protect your Personal Data from unauthorised
                    access, alteration, disclosure, or destruction. However, no
                    method of transmission over the internet or electronic
                    storage is completely secure, and we cannot guarantee
                    absolute security.
                </p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>8. Choices</h2>
                <p>
                    You have the following rights regarding your Personal Data:
                </p>
                <ul className='list-disc pl-6'>
                    <li>
                        Access: Request access to the Personal Data we hold
                        about you.
                    </li>
                    <li>
                        Correction: Request correction of inaccurate or
                        incomplete Personal Data.
                    </li>
                    <li>
                        Deletion: Request deletion of your Personal Data,
                        subject to legal or contractual obligations.
                    </li>
                    <li>
                        Opt-Out: Opt-out of receiving marketing communications
                        at any time by following the instructions provided in
                        our communications or by contacting us.
                    </li>
                </ul>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    9. Your Rights
                </h2>
                <p>
                    Under applicable data protection laws, you have the right
                    to:
                </p>
                <ul className='list-disc pl-6'>
                    <li>Access your Personal Data.</li>
                    <li>
                        Request correction or deletion of your Personal Data.
                    </li>
                    <li>
                        Restrict or object to processing of your Personal Data.
                    </li>
                    <li>
                        Data portability, allowing you to obtain and reuse your
                        data.
                    </li>
                    <li>
                        To exercise these rights, please contact us using the
                        details provided in the “How to Reach Us” section.
                    </li>
                </ul>
                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    10.Controllers and Responsible Companies
                </h2>
                <p>
                    PLAYERAPP LTD is the data controller responsible for your
                    Personal Data. Our parent company, REPRESENT FOOTBALL LTD,
                    may also be involved in the processing of your data.
                </p>
                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    11. Cookies
                </h2>
                <p>
                    We use Cookies to enhance your experience on our Platform.
                    Cookies are small text files placed on your device that help
                    us remember your preferences and understand how you use the
                    Platform
                </p>
                <p>Types of Cookies We Use:</p>
                <ul className='list-disc pl-6'>
                    <li>
                        Essential Cookies: Necessary for the operation of the
                        Platform. These cookies enable core
                    </li>
                    <li>
                        functionalities such as security, network management,
                        and accessibility.
                    </li>
                    <li>
                        Performance Cookies: Collect information about how you
                        use the Platform, such as pages
                    </li>
                    <li>
                        visited and any issues encountered. This helps us
                        improve the Platform’s performance.
                    </li>
                    <li>
                        Functionality Cookies: Allow the Platform to remember
                        your preferences and improve your experience.
                    </li>
                    <li>
                        Targeting Cookies: Used to deliver adverts relevant to
                        you and your interests.
                    </li>
                </ul>
                <p>Managing Cookies:</p>
                <p>
                    You can manage or disable Cookies through your browser
                    settings. However, please note that disabling Cookies may
                    affect your experience on the Platform and limit some
                    features. For more information about Cookies and how we use
                    them, please contact us at hello@playerapp.co
                </p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    12. How to Reach Us
                </h2>
                <p>
                    For any questions or concerns regarding this Privacy Policy
                    or our data practices, please contact us at: Email:
                    hello@playerapp.co Mailing Address: 4th Floor Charles House,
                    108-110 Finchley Road, London, United Kingdom, NW3 5JJ
                </p>
                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    13. Other Things You Should Know
                </h2>
                <p>
                    We may update this Privacy Policy from time to time. When we
                    make changes, we will update the “Last Updated” date at the
                    top of this policy. We encourage you to review this policy
                    periodically to stay informed about how we are protecting
                    your Personal Data
                </p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    14. Privacy Policy Changes
                </h2>
                <p>
                    We may update this Privacy Policy occasionally. Any changes
                    will be posted on this page with an updated “Last Updated”
                    date. Your continued use of the Platform after any changes
                    constitutes your acceptance of the revised policy.
                </p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    15. Change Log
                </h2>
                <p>16/09/2024: Initial version of the Privacy Policy.</p>

                <h2 className='text-2xl font-semibold mt-6 mb-4'>
                    How to Reach Us
                </h2>
                <p>
                    For any questions or concerns regarding this Privacy Policy
                    or our data practices, please contact us at:
                </p>
                <p>
                    Email:{' '}
                    <a
                        href='mailto:hello@playerapp.co'
                        className='text-blue-600 hover:underline'
                    >
                        hello@playerapp.co
                    </a>
                </p>
                <p>
                    Mailing Address: 4th Floor Charles House, 108-110 Finchley
                    Road, London, United Kingdom, NW3 5JJ
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
